// import config from 'config';

/* eslint-disable */
import { authHeader } from '../_helpers';
import { api } from '../_helpers/api';
import * as Cookies from 'js-cookie';

// export const userService = {
//     login,
//     logout,
//     getAll
// };

export async function getDataBasicInformation(id_user) {
    return api.fetchData('/profile/basic-information', {
        id_user : id_user
    }).then(res => {
        return res.data;
    });
}

export async function submitDataBasicInformation(form) {
    if (form.id) {
        return api.postData('/profile/update-basic-information',form,true)
        // .then(handleResponse)
        .then(response => {
            return response.data;
        });
    }else{
        return api.postData('/profile/store-basic-information',form,true)
        // .then(handleResponse)
        .then(response => {
            return response.data;
        });
    }
    
}

export async function getDataRingkasanDiri(id_user) {
    return api.fetchData('/profile/get-summary', {
        id_user : id_user
    }).then(res => {
        return res.data;
    });
}

export async function submitDataRingkasanDiri(form) {
    if (form.id) {
        return api.postData('/profile/update-summary',form,true)
        .then(response => {
            return response.data;
        });
    }else{
        return api.postData('/profile/store-summary',form,true)
        // .then(handleResponse)
        .then(response => {
            return response.data;
        });
    }
    
}

export async function getDataEducation(id_user) {
    return api.fetchData('/profile/get-education',{
        id_user: id_user
    }).then(res => {
        return res.data;
    });
}

export async function submitDataEducation(form) {
    return api.postData('/profile/store-education',form,true)
        // .then(handleResponse)
        .then(response => {
            return response.data;
        });
    
}

export async function getDataCertification(id_user) {
    return api.fetchData('/profile/get-certification', {
        id_user : id_user
    }).then(res => {
        return res.data;
    });
}

export async function submitDataCertification(form) {
    return api.postData('/profile/store-certification',form,true)
        // .then(handleResponse)
        .then(response => {
            return response.data;
        });
    
}

export async function getDataWork(id_user) {
    return api.fetchData('/profile/get-work',{
        id_user: id_user
    }).then(res => {
        return res.data;
    });
}

export async function getDataSoftHardSkill(id_user) {
    return api.fetchData('/profile/get-soft-hard-skill', {
        'id_user' : id_user
    }).then(res => {
        return res.data;
    });
}


export async function submitDataWork(form) {
    return api.postData('/profile/store-work',form,true)
        // .then(handleResponse)
        .then(response => {
            return response.data;
        });
    
}

export async function submitSoftHardSkill(form) {
    return api.postData('/profile/store-soft-hard-skill',form,true)
        // .then(handleResponse)
        .then(response => {
            return response.data;
        });
    
}

export async function getDataAchivment(id_user) {
    return api.fetchData('/profile/get-achivment', {
        id_user: id_user
    }).then(res => {
        return res.data;
    });
}

export async function submitDataAchivment(form) {
    return api.postData('/profile/store-achivment',form,true)
        // .then(handleResponse)
        .then(response => {
            return response.data;
        });
    
}

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('user');
}

function getAll() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(`http://localhost:8080/users`, requestOptions).then(handleResponse);
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                location.reload(true);
            }
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}